<template>
  <div class="ak-card__body" :class="classes">
    <template v-if="$slots.default">
      <slot />
    </template>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { padding } from './Cards.config'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-card-body :type="'comfy">
   *  <p>Lorem ipsum dolor.</p>
   * </ak-card-body>
   */
  name: 'AkCardBody',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Object}
     * @prop {String} size - the type of the property
     * @prop {String} default - the default value of the property
     * @description Controls what type of card padding to use
     * .ie small/large ect.
     */
    size: {
      validator: (v) => padding.indexOf(v) >= 0,
      type: String,
      default: padding[0],
    },

    /**
     * @type {Boolean}
     * @description determines if the relative class should be applied to the card body
     */
    relative: {
      type: Boolean,
      default: false,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    const classes = computed(() => {
      const res = []

      if (typeof props.size === 'string' && props.size.length) {
        res.push(`ak-card__body--${props.size}`)
      }

      if (props.relative) {
        res.push('relative')
      }

      return res
    })

    return {
      classes,
    }
  },
})
</script>
<style lang="scss">
@import '../../scss/_settings.scss';
.ak-card__body {
  padding: $spacing;
  display: flex;

  &--flush {
    padding: 0;
  }

  &--small {
    padding: $spacing-small;
  }

  &--large {
    @media screen and #{$mq-lap-up} {
      padding: $spacing-large;
    }
  }

  &.text-center {
    flex-grow: 1;
    justify-content: center;
    align-items: center;
  }
}
</style>
